<template>
  <div class="sidebar-block">
    <slot />
  </div>
</template>

<script>
/**
 * Componente usado para inserir o conteúdo dos blocos da barra lateral
 */
export default {
  name: 'SidebarBlock'
}
</script>

<style lang="scss" scoped>
.sidebar-block {
  padding: 35px 15px 0;
  text-align: left;

  .button {
    width: 100%;
  }
}
</style>
